import { useSelector } from 'react-redux';

import { SYSTEM_PROPERTIES } from 'constants/properties';
import useCompanyId from 'hooks/useCompanyId';

// Specific module, not the `store/companies/selectors` barrel — the barrel transitively requires
// the ColumnFilterElement component graph (via leadSources.selectors -> constants/options), which
// breaks consumers' lean test environments and mirrors the circular-require hazard documented in
// useResolvedDisclosuresSendAction.
import { selectCompanyPropertyByPropertyName } from 'store/companies/selectors/properties.selectors';

// Per-tenant kill switch for the Path to Submission widget. Opt-out: absent/false keeps the widget
// wherever its channel + registration gate already allows it; 'true' hides it outright and, with it,
// the conditions / bundle-history / AUS-prefill fetches the widget owns. Company properties are
// already loaded by LoanApplicationContent, so this adds no fetch.
const useIsPathToSubmissionDisabled = () => {
  const companyId = useCompanyId();

  const disabledProperty = useSelector(
    selectCompanyPropertyByPropertyName(companyId, SYSTEM_PROPERTIES.PATH_TO_SUBMISSION_DISABLED),
  );

  return disabledProperty?.propertyValue === 'true';
};

export default useIsPathToSubmissionDisabled;
